import { ApiError } from "@/lib/apiClient";
import { formatValidationDetail } from "@/lib/apiErrorDetail";

export { formatValidationDetail } from "@/lib/apiErrorDetail";

/** Lesbare deutsche Fehlermeldung aus ApiError oder beliebigem Fehler. */
export function formatApiError(err: unknown, fallback: string): string {
  if (err instanceof ApiError) {
    if (err.status === 0) {
      const base =
        err.message ||
        "Verbindung zum Server fehlgeschlagen. Bitte Netzwerk, VPN und Anmeldung prüfen.";
      if (base.includes("Verbindung zum Server") || base.includes("Verbindung beim Hochladen")) {
        return `${base} Bei laufendem Import kann der Vorgang auf dem Server weiterlaufen – Seite neu laden und den Upload in „Aktuelle Uploads“ fortsetzen.`;
      }
      return base;
    }
    if (err.status === 401) {
      return "Anmeldung abgelaufen oder fehlend. Bitte Seite neu laden und erneut anmelden.";
    }
    if (err.status === 403) {
      return "Keine Berechtigung für diese Aktion (Stammdaten-Schreibrecht erforderlich).";
    }
    if (err.status === 404) {
      if (err.body && typeof err.body === "object" && "detail" in err.body) {
        return formatValidationDetail((err.body as { detail: unknown }).detail);
      }
      return err.message || "Der angeforderte Upload oder Import-Job wurde nicht gefunden.";
    }
    if (err.status === 409) {
      if (err.body && typeof err.body === "object" && "detail" in err.body) {
        return formatValidationDetail((err.body as { detail: unknown }).detail);
      }
      return err.message || "Der Upload ist noch nicht bereit. Bitte warten oder die Analyse erneut starten.";
    }
    if (err.status === 413) {
      return (
        formatValidationDetail(
          err.body && typeof err.body === "object" && "detail" in err.body
            ? (err.body as { detail: unknown }).detail
            : err.message,
        ) || "Die Datei ist zu groß für den Server (HTTP 413). Bitte Administrator kontaktieren."
      );
    }
    if (err.status === 422) {
      if (err.body && typeof err.body === "object" && "detail" in err.body) {
        return formatValidationDetail((err.body as { detail: unknown }).detail);
      }
      return err.message || fallback;
    }
    if (err.status === 504 || err.status === 502) {
      return "Der Server hat die Anfrage nicht rechtzeitig beantwortet (Gateway-Timeout). Bei großen SQL-Dumps bitte erneut versuchen – Upload und Analyse laufen jetzt getrennt.";
    }
    if (err.status >= 500) {
      if (err.body && typeof err.body === "object" && "detail" in err.body) {
        const detail = formatValidationDetail((err.body as { detail: unknown }).detail);
        if (detail !== "Unbekannter Serverfehler.") {
          return `Serverfehler: ${detail}`;
        }
      }
      return err.message || "Unerwarteter Serverfehler. Bitte später erneut versuchen oder den Administrator informieren.";
    }
    if (err.body && typeof err.body === "object" && "detail" in err.body) {
      return formatValidationDetail((err.body as { detail: unknown }).detail);
    }
    return err.message || fallback;
  }
  if (err instanceof Error) return err.message || fallback;
  return fallback;
}
